import { PermissionRequirement } from './permission.model';

export const CUSTOMERS_PERMISSIONS = {
  list: { resource: 'customers', action: 'index' },
  show: { resource: 'customers', action: 'show' },
  create: { resource: 'customers', action: 'create' },
  update: { resource: 'customers', action: 'update' },
  destroy: { resource: 'customers', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;
